module.exports = __webpack_public_path__ + "static/media/p-radar.e91a38c0.png";